import StatGrid from '@commons/stats'
const AdminDahsboardPage = () => {
  const items: any = [
    {
      title: 'Total Patients',
      value: 155,
      icon: 'patient',
      bg: 'danger50',
    },
    {
      title: 'Total Doctors',
      value: '25',
      icon: 'doctor',
      bg: 'secondary50',
    },
    {
      title: 'Total Clinic',
      value: '25',
      icon: 'clinic',
      bg: 'green100',
    },
    {
      title: 'Total Pharmacy',
      value: '25',
      icon: 'pharmacy',
      bg: 'yellow100',
    },
    {
      title: 'Upcoming Appointment',
      value: '25',
      icon: 'appointment',
      bg: 'orange100',
    },
    {
      title: 'Lab Orders',
      value: '25',
      icon: 'lab',
      bg: 'yellow150',
    },
    {
      title: 'Medicine Order',
      value: '25',
      icon: 'medicine',
      bg: 'green150',
    },
    {
      title: 'Total Earning',
      value: 'Rs.23,459',
      icon: 'money',
      bg: 'yellow50',
    },
  ]
  return (
    <>
      <StatGrid items={items} />
    </>
  )
}

export default AdminDahsboardPage
